<template>
  <div class="card" :class="{'bg-danger text-white': isTaskOverdue(task)}">
    <div class="card-body">
      <div class="row">
        <!-- Left column -->
        <div class="col-md-8">
          <div class="task-card-left-wrapper">
            <div class="left">
              <input @change="() => toggleTask()" :checked="task.completed_at" type="checkbox"
                     :disabled="isToggling">
            </div>
            <div class="right">
              <b class="subject" :class="{'text-white': isTaskOverdue(task)}">{{ task.description }}</b><br>
              <div class="property mt-1">
                <span>Ticket:</span> <a href="#" :class="{'text-white': isTaskOverdue(task)}" @click.prevent="goToTicket(task.ticket)">{{ task.ticket.subject }}</a>
              </div>
              <div class="property mt-1">
                Created {{ displayTimeAgo(task.created_at) }}
              </div>
            </div>
          </div>
        </div>
        <!-- / Left column -->

        <!-- Right column -->
        <div class="col-md-4 right-column">
          <div class="property">
            <i class="bx bx-alarm mr-1 font-weight-bold"></i> {{ displayTimestamp(task.deadline) }}
          </div>
        </div>
        <!-- / Right column -->
      </div>
    </div>
  </div>
</template>

<script>
import Forms from "../../../../../mixins/Forms";
import Dates from "../../../../../mixins/Dates";
import Tasks from "../../../../../mixins/Tasks";

import axios from 'axios';
let _ = require('lodash');

export default {
  name: "TaskCard",
  props: ['task'],
  mixins: [Dates, Tasks, Forms],
  data() {
    return {
      serverErrors: [],
      isToggling: false
    }
  },
  methods: {
    getTicketUrl(ticket) {
      return '/tickets/' + ticket.id;
    },

    goToTicket(ticket) {
      this.$router.push(this.getTicketUrl(ticket));
    },

    toggleTask() {
      let vm = this;
      vm.isToggling = true;
      axios.post(API_BASE + '/tickets/' + this.task.ticket_id + '/tasks/' + this.task.id + '/toggle-completed').then(r => {
        vm.isToggling = false;
        if (this.task.completed_at) {
          this.task.completed_at = null;
        } else {
          this.task.completed_at = moment();
        }
      }).catch(e => {
        vm.isToggling = false;
        vm.notifyErrors(e);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 0.9rem 1rem;
}

.property {
  font-size: 11px;

  span {
    font-weight: 500;
    margin-right: 5px;
  }
}


.task-card-left-wrapper {
  display: flex;

  .left {
    flex-shrink: 1;
    width: 70px;
    align-items: center;
    display: flex;
    padding-left: 16px;
  }

  .right {
    flex: 1;
  }

  .subject {
    font-weight: 600;
    color: #2c5cc5;
  }
}

.right-column {
  display: flex;
  align-items: center;
}
</style>